import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "multi-tag-input__label" }
const _hoisted_2 = {
  key: 0,
  class: "multi-tag-input__label-text"
}
const _hoisted_3 = { class: "multi-tag-input__chip-text" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["placeholder", "disabled"]

import { ref, watch } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';

/**
 * 自由入力の複数値（タグ）入力。
 * 値はカンマ結合の単一文字列として `modelValue` を入出力する。
 * カンマは区切り文字として扱うため、各タグにカンマは含められない。
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'MultiTagInput',
  props: {
    modelValue: {},
    label: {},
    placeholder: { default: '' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "editing"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

/**
 * カンマ結合文字列をタグ配列へ変換する。
 * @param value - カンマ結合文字列
 * @returns 空要素を除いたタグ配列
 */
const parseTags = (value: string): string[] =>
  value
    ? value
        .split(',')
        .map((tag) => tag.trim())
        .filter((tag) => tag.length > 0)
    : [];

const tags = ref<string[]>(parseTags(props.modelValue));
const inputText = ref<string>('');

watch(
  () => props.modelValue,
  (value) => {
    tags.value = parseTags(value);
  }
);

/** 現在のタグ配列をカンマ結合文字列として親へ通知する */
const emitValue = () => {
  emit('update:modelValue', tags.value.join(','));
};

/**
 * 入力中テキストをタグとして確定する。
 * カンマ区切りの貼り付けにも対応し、重複・空文字は追加しない。
 */
const commitInput = () => {
  const candidates = parseTags(inputText.value);
  if (candidates.length === 0) {
    inputText.value = '';
    return;
  }
  let didAdd = false;
  candidates.forEach((candidate) => {
    if (!tags.value.includes(candidate)) {
      tags.value.push(candidate);
      didAdd = true;
    }
  });
  inputText.value = '';
  if (didAdd) emitValue();
};

/**
 * 指定indexのタグを削除する。
 * @param index - 削除するタグのindex
 */
const removeTag = (index: number) => {
  tags.value.splice(index, 1);
  emitValue();
};

/**
 * キー入力を処理する。Enterまたはカンマでタグを確定する。
 * @param event - キーボードイベント
 */
const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Enter' || event.key === ',') {
    event.preventDefault();
    commitInput();
  } else if (event.key === 'Backspace' && inputText.value === '' && tags.value.length > 0) {
    removeTag(tags.value.length - 1);
  }
};

/**
 * Input時にemit流す処理
 */
const onInput = () => {
  emit('editing');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label !== '')
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["multi-tag-input", { 'multi-tag-input--disabled': _ctx.disabled }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index + tag,
          class: "multi-tag-input__chip"
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(tag), 1),
          (!_ctx.disabled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "multi-tag-input__chip-close",
                onClick: ($event: any) => (removeTag(index))
              }, [
                _createVNode(SvgLoader, { name: "close" })
              ], 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputText).value = $event)),
        class: "multi-tag-input__field",
        type: "text",
        placeholder: tags.value.length === 0 ? _ctx.placeholder : '',
        disabled: _ctx.disabled,
        onInput: onInput,
        onKeydown: onKeydown,
        onBlur: commitInput
      }, null, 40, _hoisted_5), [
        [_vModelText, inputText.value]
      ])
    ], 2)
  ]))
}
}

})